import React from 'react';
import { Box, Button, Card, Typography, Breadcrumbs, Divider } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { FormContrato } from './components/FormContrato';
import validationSchema from './formik/validationSchema';
import formInitialValues from './formik/formInitialValues';
import { useDispatch } from 'react-redux';
import { useResponseHandler } from '../../../hooks/useResponseHandler';
import { saveContratoStore } from 'store/contratos/contratos.thunks';
// import { saveContratoStore } from './store/contratos.thunks';

export const CrearContrato = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { ResponseComponents, handleResponse } = useResponseHandler();

  const onSubmit = async (values: any, actions: any) => {
    const { typeContract, ...dataToSend } = values;
    const response = await dispatch(saveContratoStore(dataToSend));

    await handleResponse(response, 'Crear contrato', true);

    if (!response.ok) {
      actions.setSubmitting(false);
      return false;
    }

    navigate('/talento-humano/contratos');
    actions.setSubmitting(false);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {ResponseComponents}

      <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>
        Crear Contrato
      </Typography>
      <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
        <Typography color="textPrimary" sx={{ fontWeight: 700 }}>
          Talento Humano
        </Typography>
        <Link color="inherit" to="/talento-humano/contratos" style={{ textDecoration: 'none' }}>
          Gestión de Contratos
        </Link>
        <Typography color="textPrimary">Crear Contrato</Typography>
      </Breadcrumbs>

      <Divider sx={{ marginBottom: 3 }} />

      <Formik
        initialValues={formInitialValues}
        validationSchema={validationSchema[0]}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Card
            sx={{
              p: 3,
              borderRadius: 3,
              boxShadow: '0px 12px 24px -4px rgba(105, 108, 255, 0.15)',
              border: 'none',
            }}
          >
            <Typography variant="h6" sx={{ mb: 3 }}>
              Información del Contrato
            </Typography>
            <Form>
              <FormContrato />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
                <Button
                  component={Link}
                  to="/talento-humano/contratos"
                  color="inherit"
                  sx={{ borderRadius: 2, textTransform: 'none' }}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting || (!isValid && !dirty)}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    px: 3,
                    fontWeight: 600,
                  }}
                >
                  Crear Contrato
                </Button>
              </Box>
            </Form>
          </Card>
        )}
      </Formik>
    </Box>
  );
};
